/*
 * Created Date: 29-01-2024, 2:15:59 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Mon Mar 11 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { workspaceCategoriesRouterConfig } from '../Categories/configs/router'
import { workspaceClassRoomRouterConfig } from '../ClassRoom/configs/router'
// import { WorkspaceCreateExamAIRouterConfig } from '../CreateExamAI/configs/WorkspaceCreateExamAIRouterConfig'
import { WorkspaceDashboardRouterConfig } from '../Dashoard/configs/WorkspaceDashboardRouterConfig'
import { workspaceExamRouterConfig } from '../Exam/configs/router'
import { workspaceExamRoomRouterConfig } from '../ExamRoom/config/router'
import { workspacePlanRouterConfig } from '../Plan/configs/router'
import { workspaceQuestionCollectionRouterConfig } from '../QuestionCollection/configs/router'
import { workspaceSystemRouterConfig } from '../System/config/router'
import { workspaceTeamRouterConfig } from '../Team/configs/router'

const WorkspaceRouterConfig = [
	WorkspaceDashboardRouterConfig,
	workspaceExamRouterConfig,
	workspaceClassRoomRouterConfig,
	// WorkspaceExamRouterConfig,
	// WorkspaceExamDetailRouterConfig,
	// WorkspaceCreateExamAIRouterConfig,
	// WorkspaceQuickCreateExamRouterConfig,
	workspaceCategoriesRouterConfig,
	workspaceTeamRouterConfig,
	workspaceQuestionCollectionRouterConfig,
	workspaceSystemRouterConfig,
	workspacePlanRouterConfig,
	workspaceExamRoomRouterConfig
]

export default WorkspaceRouterConfig
